import React from 'react';
import styled from 'styled-components';
import { Text } from '../../util/typography';
import * as colors from '../../util/colors';
import { setPropsFromURL } from '../../util/CTA';
import { UnderlineTransitionHover } from '../../util/typography/Text';

const MenuItem = styled.li`
    margin-bottom: 8px;
`;

const StyledLink = styled.a`
    text-decoration: none;
    color: ${colors.sky};
    position: relative;

    &:hover {
        color: ${colors.skyLight};

        &::before{
        ${UnderlineTransitionHover};
        }
    }

    > span {
        color: inherit;
    }

    &::before{
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 1px;
    left: 0;
    background-color: ${colors.skyLight};
    transform-origin: left;
    transition: transform 0.3s ease-out;
    will-change: transform;
    backface-visibility: hidden;
    }
`;

const FooterLink = ({ label, url }) => {

    return (
        <MenuItem>
            <StyledLink {...setPropsFromURL(url)} data-design-category='bottom_nav_vd'>
                <Text.Caption>{label}</Text.Caption>
            </StyledLink>
        </MenuItem>
    );
};

export default FooterLink;
